module.exports = __webpack_public_path__ + "img/cooking_sketch.bb810ff5.png";